import React from 'react';
import { FileImage } from 'lucide-react';
import { parseMetadataArquivo, formatarTamanhoArquivo, formatarTipoArquivo } from '../../utils/metadataArquivo';

// Linha "tipo · tamanho · nome original" embaixo de uma prévia de imagem —
// só aparece quando existe imagem E metadata pra ela (enquete antiga, de
// antes das colunas metadata_* existirem, tem imagem sem metadata; nesse
// caso simplesmente não mostra nada, não é erro). Usado em
// UploadImagemCapa.js (capa/capa mobile) e PersonalizarFundoForm.js (fundo).
const MetadataImagem = ({ metadata }) => {
  const info = parseMetadataArquivo(metadata);
  if (!info) return null;

  return (
    <p className="flex items-center gap-1.5 text-xs text-gray-400 mt-1.5 min-w-0">
      <FileImage className="w-3.5 h-3.5 flex-shrink-0" />
      <span className="flex-shrink-0">{formatarTipoArquivo(info.tipo)}</span>
      <span className="flex-shrink-0">·</span>
      <span className="flex-shrink-0">{formatarTamanhoArquivo(info.tamanho)}</span>
      <span className="flex-shrink-0">·</span>
      <span className="truncate" title={info.nome}>{info.nome}</span>
    </p>
  );
};

export default MetadataImagem;
